import { IUploadProps } from '../types';

export const uploadMaxFileSize = (maxFileSize: IUploadProps['maxFileSize']): string | null => {
  if (!maxFileSize) return null;

  // if less than 1 mByte
  if (maxFileSize < 1048576) return String(maxFileSize / 1024) + ' KB';

  return String(maxFileSize / 1024 / 1024) + ' MB';
};

export const uploadAllowedFileTypes = (allowedFileTypes: IUploadProps['allowedFileTypes']): string[] => {
  if (!allowedFileTypes?.length) return [];

  return allowedFileTypes.map((type) => {
    if (type.includes('x-icon')) return ' ico';
    return ' ' + type.split('/')[1];
  });
};
